import React from "react";
import PropTypes from "prop-types";
import { Button } from "@orijinworks/frontend-commons";
import { useStyles } from "./view-at-link.style";

const ViewAtLink = ({ onClick, fromName }) => {
  const classes = useStyles();
  return (
    <Button
      variant="outlined"
      size="small"
      className={classes.link}
      onClick={onClick}
    >
      View at {fromName}
    </Button>
  );
};

ViewAtLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  fromName: PropTypes.string,
};

ViewAtLink.defaultProps = {
  fromName: "",
};

export default ViewAtLink;
